import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlAgnOffPremises from "./HtlAgnOffPremises";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $rulPernId: Int
    $rulSubId: Int
    $rulExitId: Int
    $rulPremId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_rules_act(where: {

            id_seq: { _eq: $rulExitId }
            r_prn_id: {_eq: $rulPernId}
            r_sub_id: {_eq: $rulSubId}        
            r_pre_id: { _eq: $rulPremId }
            firm_main_code: { _eq: $ownFirmCode }
           firm_sub_code: { _eq: $ownFirmSubCode }         
        
        
    }) {
    id_seq
    r_prn_id
    r_sub_id
    r_pre_id
    firm_main_code
    firm_sub_code
    act_class
    act_type
    date_1
    pre_type
    pre_type_2
    opr_1
    str_var_1
    str_var_2
    int_var_1
    int_var_2

    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: Int
    $rulSubId: Int
    $rulExitId: Int
    $rulPremId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $date1: date
    $actType: String
    $actPremType: String
    $actPremType2: String
    $actOpr1: String
    $actStrV1: String
    $actStrV2: String
    $actIntV1: Int
    $actIntV2: Int

   
    
  ) {
    insert_tbl_rules_act(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        id_seq: $rulExitId,  
        r_prn_id: $rulPernId,
        r_sub_id: $rulSubId,
        r_pre_id: $rulPremId,

        act_type: $actType,
        date_1: $date1,
        
        pre_type: $actPremType,
        pre_type_2: $actPremType2,
        
        opr_1: $actOpr1,
        str_var_1: $actStrV1,
        str_var_2: $actStrV2,
        int_var_1: $actIntV1,
        int_var_2: $actIntV2,
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        opt_1: { _eq: $ruleClass2 },
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;


const GET_RULES_PRE = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_RULES_OPR = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_RULES_TIME = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(
  $rulPernId: Int
  $rulSubId: Int
  $rulExitId: Int
  $rulPremId: Int
  $ownFirmCode: String
  $ownFirmSubCode: String
  $date1: date
  $actType: String
  $actPremType: String
  $actOpr1: String
  $actStrV1: String
  $actStrV2: String
  $actIntV1: Int
  $actIntV2: Int
 


    
  ) {
    update_tbl_rules_act(
      where: {
            id_seq: { _eq: $rulExitId }
            r_prn_id: {_eq: $rulPernId}
            r_sub_id: {_eq: $rulSubId}        
            r_pre_id: { _eq: $rulPremId }
            firm_main_code: { _eq: $ownFirmCode }
            firm_sub_code: { _eq: $ownFirmSubCode }      
      }
      _set: {
        
        
        act_type: $actType
        date_1: $date1
        pre_type: $actPremType        
        opr_1: $actOpr1
        str_var_1: $actStrV1
        str_var_2: $actStrV2
        int_var_1: $actIntV1
        int_var_2: $actIntV2
       
       
      }
    ) {
      affected_rows
    }
  }
`; 




const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlAgnOffExit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext);
   const {varCode12, setVarCode12} = useContext(ThemeContext);
   const {varCode13, setVarCode13} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { rulPernId: varCode,
         ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, 
         rulSubId: varCode8, rulPremId: varCode10,  rulExitId: varCode13 },
  });

  console.log("prn:", varCode);
 console.log("sub:", varCode8);
 console.log("prem:", varCode10);
 console.log("exiid:", varCode13);


  const firmData = data && data.tbl_rules_act ? data.tbl_rules_act[0] : null;
  //const firmData2 = data && data.tbl_rules_sub_premises ? data.tbl_rules_sub_premises[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  const [rulExitIdTrg, setRulExitIdTrg] = useState("");  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulExitId, setRulExitId] = useState(firmData ? firmData.id_seq : "");   
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.r_sub_id : "");  
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.r_prn_id : ""); 
  const [rulPremId, setRulPremId] = useState(firmData ? firmData.r_pre_id : ""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.rules_sub_name : ""); 
  const [actType, setActType] = useState(firmData ? firmData.act_type : ""); //act Type Dısk- Pay - Inv
  const [actPremType, setActPremType] = useState(firmData ? firmData.pre_type : ""); // date- rez- check-in - checkout
  const [actPremType2, setActPremType2] = useState(firmData ? firmData.pre_type_2 : "");
  const [actStrV1, setActStrV1] = useState(firmData ? firmData.str_var_1 : ""); // % , CUR , etc disk type
  const [actStrV2, setActStrV2] = useState(firmData ? firmData.str_var_2 : ""); // day - hour - min
  const [actIntV1, setActIntV1] = useState(firmData ? firmData.int_var_1 : "0"); // % , CUR , etc disk value
  const [actIntV2, setActIntV2] = useState(firmData ? firmData.int_var_2 : "0"); // Str1 Value rez date 5 day
  const [actOpr1, setActOpr1] = useState(firmData ? firmData.opr_1 : ""); // 
  const [date1, setDate1] = useState(firmData ? new Date(firmData.date_1): new Date());

  
  
  

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const select_rule_result_hint = messages[currentLocale].select_rule_result_hint;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_persent_title = messages[currentLocale].rule_persent_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const rule_type_name_title = messages[currentLocale].rule_type_name_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const when_title = messages[currentLocale].when_title;
  const value_title = messages[currentLocale].value_title;
  const calcutate_title = messages[currentLocale].calcutate_title;
  const new_result_btn = messages[currentLocale].new_result_btn;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;


  



  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "EXIT", ruleClass2: varCode9 },
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_RULES_PRE, {
    variables: {lang: currentLocale, defType: "PREMA" },
  });

  const { loading: defLoading3, error: defError3, data: defData3 } = useQuery(GET_RULES_OPR, {
    variables: {lang: currentLocale, defType: "OPR" },
  });

  const { loading: defLoading4, error: defError4, data: defData4 } = useQuery(GET_RULES_TIME, {
    variables: {lang: currentLocale, defType: "PREMT" },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulExitIdTrg !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulExitIdTrg, setRulExitIdTrg]);


  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (actType === 'REDP') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
      setActStrV1("%");  
    
    }
  }, [actType]);


  useEffect(() => {
    if (defData && defData.tbl_gnl_def) {
      const rulesClasstems = defData.tbl_gnl_def.find(item => item.code === actType);
      if (rulesClasstems) {
        setRulesName(rulesClasstems.name);
      }
    }
  }, [actType, setActType, defData]);

  

  useEffect(() => {
    if (firmData) {        
        setRulExitId(firmData.id_seq);  
        setRulPernId(firmData.r_prn_id);  
        setRulPremId(firmData.r_pre_id); 
        setRulSubnId(firmData.r_sub_id);      
        setActType(firmData.act_type);
        
        setDate1(new Date(firmData.date_1));
        setActPremType(firmData.pre_type);
        setActStrV1(firmData.str_var_1);
        setActStrV2(firmData.str_var_2);
        setActIntV1(firmData.int_var_1);
        setActIntV2(firmData.int_var_2);
        setActOpr1(firmData.opr_1);

        setRulesName(firmData.rules_sub_name);    


       
       
        
     
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {     
       
        rulPernId: varCode,
        rulSubId: varCode8,
        rulPremId: varCode10,      
        rulExitId: rulExitId,
        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,        
        actType: actType,
        actOpr1:actOpr1,
        
        date1: new Date(date1).toLocaleDateString(),
        actPremType: actPremType,
        actStrV1: actStrV1,
        actStrV2: actStrV2,
        actIntV1: actIntV1,
        actIntV2: actIntV2,
      


        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['actType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
    //  ruleClass: "Rules Class",
      actType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulExitIdTrg(updatedIdSeq); 
        setRulExitId(updatedIdSeq); 
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulExitIdTrg);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {


   

        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: varCode,
        rulSubId: varCode8,
        rulPremId: varCode10,
        rulExitId: rulExitId,
        date1: new Date(date1).toLocaleDateString(),
        actType: actType,
        actPremType: actPremType,
        actPremType2: actPremType2,
        actOpr1: actOpr1,
        actStrV1: actStrV1,
        actStrV2: actStrV2,
        actIntV1: actIntV1,
        actIntV2: actIntV2,
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
        setRulExitIdTrg(''); 
        refetch();
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
  //  setVarCode11(ruleType); //EBO
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
   // setVarCode10(0);  
   // setVarCode11(ruleType); //EBO
    setVarCode10(0); //EBO
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems2 = defData2 && defData2.tbl_gnl_def
  ? defData2.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems3 = defData3 && defData3.tbl_gnl_def
  ? defData3.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const rulesClasstems4 = defData4 && defData4.tbl_gnl_def
  ? defData4.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   



    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">
      <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={rulExitId}
    onChange={(e) => setRulExitId(e.target.value)}
    readOnly
    />
  </div>  
  
  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_class_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actType} 
    onChange={(e) => setActType(e.target.value)} autoComplete="off"/>
    
  </div>


  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {rule_class_name_title}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={actType}
         options={rulesClasstems}
         onChange={(e) => setActType(e.value)}
         placeholder={select_rule_result_hint}
         />
       </div> 
 
  </div>  
</p>
   </Fieldset>
       </div>

       {actType === "REDP" && (

       <Fieldset>
             <p className="my-0  ">   
  
  <div className="flex gap-3 ">


  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_persent_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actIntV1} 
    onChange={(e) => setActIntV1(e.target.value)} autoComplete="off"/>
    
  </div>
  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_persent_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actStrV1} 
    onChange={(e) => setActStrV1(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_type_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={rulesName} 
    onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>
    
  </div>

  
  
      </div>
     

</p>
   </Fieldset>
    )}   {/* REDP  */}
 
       </div>  

         {actType === "PAYP" && (  

        <Fieldset>
             <p className="my-0  ">
      <div className="flex gap-4">

      <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_persent_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actIntV1} 
    onChange={(e) => setActIntV1(e.target.value)} autoComplete="off"/>
    
  </div>
  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_persent_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actStrV1} 
    onChange={(e) => setActStrV1(e.target.value)} autoComplete="off"/>
    
  </div>
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_type_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={actPremType}
    onChange={(e) => setActPremType(e.target.value)}
    readOnly
    />
  </div>

 

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {rule_type_name_title}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={actPremType}
         options={rulesClasstems2}
         onChange={(e) => setActPremType(e.value)}
         placeholder={select_rule_result_hint}
         />
       </div> 


 
  </div>

  
  <div className="flex gap-3 my-5">

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {when_title}
       </label>
       <Dropdown
       className="h-11  w-2/3 rounded-md" // Bu satır eklenmiştir
        style={{ width: '124px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={actOpr1}
         options={rulesClasstems3}
         onChange={(e) => setActOpr1(e.value)}
         placeholder={"Select"}
         />
       </div>

  <div className="w-1/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{value_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={actIntV2} 
    onChange={(e) => setActIntV2(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {calcutate_title}
       </label>
       <Dropdown
       className="h-11  w-2/3 rounded-md" // Bu satır eklenmiştir
        style={{ width: '124px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={actStrV2}
         options={rulesClasstems4}
         onChange={(e) => setActStrV2(e.value)}
         placeholder={"Select "}
         />
       </div>

  <div className="w-1/3 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Date"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={date1} dateFormat="dd/mm/yy"
        onChange={(e) => setDate1(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      </div>
</p>
   </Fieldset>     

)}   {/* PAYP  */}


{actType === "RDPC" && (

<Fieldset>
      <p className="my-0  ">   

<div className="flex gap-3 ">


<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actIntV1} 
onChange={(e) => setActIntV1(e.target.value)} autoComplete="off"/>

</div>
<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actStrV1} 
onChange={(e) => setActStrV1(e.target.value)} autoComplete="off"/>

</div>

<div className="w-1/3 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_type_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={rulesName} 
onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>

</div>



</div>


</p>
</Fieldset>
)}   {/* RDPC  */}

{actType === "SPPC" && (

<Fieldset>
      <p className="my-0  ">   

<div className="flex gap-3 ">


<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actIntV1} 
onChange={(e) => setActIntV1(e.target.value)} autoComplete="off"/>

</div>
<div className="w-1/6 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_persent_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={actStrV1} 
onChange={(e) => setActStrV1(e.target.value)} autoComplete="off"/>

</div>

<div className="w-1/3 p-inputtext-sm flex-column gap-3">
<label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
htmlFor="firmname">{rule_type_title}</label>
<InputText className="w-full text-base" 
id="firmname" value={rulesName} 
onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>

</div>



</div>


</p>
</Fieldset>
)}   {/* SPPC  */}

    <div className="flex justify-end mt-2 gap-4 ">  
  
  <div className="w-1/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-1/4">
    <Button
      label={new_result_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div> 
  
  </div>
    
    
    
 
 
);
};

export default HtlAgnOffExit;
